const types = {
  GET_TEMPLATES_START: 'GET_TEMPLATES_START',
  GET_TEMPLATES_SUCCESS: 'GET_TEMPLATES_SUCCESS',
  GET_TEMPLATES_FAILURE: 'GET_TEMPLATES_FAILURE',
  GET_TEMPLATE_START: 'GET_TEMPLATE_START',
  GET_TEMPLATE_SUCCESS: 'GET_TEMPLATE_SUCCESS',
  GET_TEMPLATE_FAILURE: 'GET_TEMPLATE_FAILURE',
  CREATE_TEMPLATE_START: 'CREATE_TEMPLATE_START',
  CREATE_TEMPLATE_SUCCESS: 'CREATE_TEMPLATE_SUCCESS',
  CREATE_TEMPLATE_FAILURE: 'CREATE_TEMPLATE_FAILURE',
  UPDATE_TEMPLATE_START: 'UPDATE_TEMPLATE_START',
  UPDATE_TEMPLATE_SUCCESS: 'UPDATE_TEMPLATE_SUCCESS',
  UPDATE_TEMPLATE_FAILURE: 'UPDATE_TEMPLATE_FAILURE',
  DELETE_TEMPLATE_START: 'DELETE_TEMPLATE_START',
  DELETE_TEMPLATE_SUCCESS: 'DELETE_TEMPLATE_SUCCESS',
  DELETE_TEMPLATE_FAILURE: 'DELETE_TEMPLATE_FAILURE',
  CLEAR_ERROR: 'CLEAR_ERROR',
};

export default types;
